module.exports = __webpack_public_path__ + "static/media/ISO_C++_Logo.8cc47c68.svg";